import React, { useEffect } from 'react';
import { BsFillInfoCircleFill, BsArrowRepeat } from 'react-icons/bs';
import { Tooltip } from 'react-tooltip';
import { locales } from '../../translations/locales';
import ModalNewGame from '../modals/ModalNewGame';

const MyLobby = (props) => {
    const { data, ModuleRP, locale, theme } = props;
    useEffect(() => {
        const sortData = () => {
            data.sort((a, b) => {
                return b.players.length - a.players.length;
            });
        };
        if (data.length > 0) {
            sortData();
        }
    });

    return (
        <>
            <ModalNewGame locale={locale} />
            <div className='textFull w-100'>
                <div className='row m-5'>
                    <div className='col-5 m-3 p-3'>
                        <img src="/images/modrp.webp" className="as-logo" alt="ALERTES SPÉCIALES" />
                    </div>
                    <div className='col-5 m-3 p-3 alert alert-warning text-left'>
                        <h4 className='alert-heading'>{locales[locale].defaults.presentationTitle}</h4>
                        <h5 className='alert-heading'>{locales[locale].defaults.presentationSubTitle}</h5>
                        <p className=''>{locales[locale].defaults.presentationText}</p>
                        <h5>{locales[locale].defaults.descriptionTitle}</h5>
                        <p> {locales[locale].defaults.descriptionText.split('<br />').map((text, index) => (
                            <React.Fragment key={index}>
                                {index > 0 && <br />}
                                {text}
                            </React.Fragment>
                        ))}</p>
                        <h5>{locales[locale].defaults.notAGameTitle}</h5>
                        <p>{locales[locale].defaults.notAGameText}</p>
                    </div>
                    <div className='col-2'></div>
                </div>
                <div>
                    <h3 className='text-danger'>NEXSIMU | MOD RP ALPHA V{ModuleRP.version}</h3>
                </div>
                <div className='container overflow-auto' id='lobby'>
                    <div className={`bg-${theme === 'DARK' ? 'dark' : 'light'} w-100 text-${theme === 'DARK' ? 'light' : 'dark'} text-center`}>
                        <h2>
                            {locales[locale].gamesTable.titleMyGames}
                        </h2>
                    </div>

                    <table className={`table table-hover table-${theme === 'DARK' ? 'dark' : 'light'}`}>
                        <thead>
                            <tr>
                                <th>{locales[locale].gamesTable.gameNames}</th>
                                <th>{locales[locale].gamesTable.gameDescription}</th>
                                <th>{locales[locale].gamesTable.gamePlayersNb}</th>
                                <th><BsArrowRepeat
                                    id='refreshList'
                                    className='float-right cursor-pointer'
                                    data-tip data-tooltip-id='refreshList'
                                    onClick={() => {
                                        ModuleRP.setPage('Logo', locales[locale].loading); ModuleRP.refreshList();
                                    }}
                                />
                                    <Tooltip id='refreshList' place='top' effect='solid' className='text-center'>
                                        {locales[locale].refresh}
                                    </Tooltip>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                data.length > 0 ?
                                    data.map((game) =>
                                    (<tr key={game.id}>
                                        <td>{game.name}</td>
                                        <td>{game.description}</td>
                                        <td>{game.players.length}
                                            <span data-tip data-tooltip-id={'players_' + game.id}>{<BsFillInfoCircleFill className='m-1' />}</span>
                                            <Tooltip
                                                id={'players_' + game.id}
                                                place='right'
                                                effect='solid'
                                                className='text-center'
                                                data-html={true}
                                            >
                                                {game.players.map((player) => (
                                                    <div key={player.id + '_' + game.id}>{player.name}</div>
                                                ))}
                                            </Tooltip>
                                        </td>
                                        <td>
                                            <button className='btn btn-sm btn-success float-right' onClick={() => ModuleRP.loadGame(game.id)}>
                                                {locales[locale].load}
                                            </button>
                                        </td>
                                    </tr>),
                                    ) :
                                    (
                                        <tr>
                                            <td colSpan={4}>{locales[locale].gamesTable.noGame}</td>
                                        </tr>
                                    )
                            }
                            <tr>
                                <td colSpan={4} className='text-center'>
                                    <button className='btn btn-sm btn-success m-1' data-toggle='modal' data-target='#modalRp'>
                                        {locales[locale].gamesTable.newGame}
                                    </button>
                                    <button className='btn btn-sm btn-primary m-1' onClick={() => ModuleRP.getAllGames()}>
                                        {locales[locale].gamesTable.searchGame}
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

export default MyLobby;
